module.exports = __webpack_public_path__ + "static/media/submit-button.4e8a871a.svg";